import { render } from "./DateTimeDisplay.vue?vue&type=template&id=7870e9c0"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=js"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__